const slugify = require("slugify");

const safeSlugify = (path) =>
  path
    .split("/")
    .filter(Boolean)
    .map((v) => slugify(v, { lower: true }))
    .join("/");

module.exports = safeSlugify;
